import { render, staticRenderFns } from "./mark.vue?vue&type=template&id=717338a0&scoped=true"
import script from "./mark.vue?vue&type=script&lang=ts"
export * from "./mark.vue?vue&type=script&lang=ts"
import style0 from "./mark.vue?vue&type=style&index=0&id=717338a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717338a0",
  null
  
)

export default component.exports